<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div v-if="loading">Carregando unidades consumidoras...</div>
        <material-card
          color="success"
          title="Unidades Consumidoras"
          text="Unidades Consumidoras cadastrados na plataforma"
          v-if="!loading"
        >
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-progress-linear
            v-if="loading"
            height="2"
            v-slot:loading
            color="cyan"
            indeterminate
          ></v-progress-linear>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :total-items="totalUCs"
            :loading="loading"
            :items="consumerunits"
            no-data-text="Não há unidades consumidoras cadastradas"
            rows-per-page-text="Linhas por página"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.id }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.customer_number }}</td>
              <td>{{ item.power_plant_id }}</td>
              <td>{{ item.percentage }}</td>
            </template>
            <v-alert
              v-slot:no-results
              :value="true"
              color="error"
              icon="warning"
              >Sua busca para "{{ search }}" não retornou resultados.</v-alert
            >
            <template v-slot:pageText="items"
              >Linhas {{ items.pageStart }} - {{ items.pageStop }} de
              {{ totalUCs }}</template
            >
          </v-data-table>
          <!-- <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
          </div> -->
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
// import { getUser } from "../services/users"

export default {
  data: () => ({
    loading: false,
    search: "",
    totalUCs: 500,
    // pagination: {},
    headers: [
      {
        text: "Unidade Consumidora",
        align: "left",
        sortable: true,
        value: "installation_number",
      },
      { text: "Nome", value: "name", align: "center" },
      { text: "N. Cliente", value: "customer_number", align: "center" },
      { text: "Planta", value: "power_plant_id", align: "center" },
      { text: "% de Aluguel", value: "percentage", align: "rigth" },
      // { text: 'Iron (%)', value: 'iron', align: 'center' }
    ],
  }),
  watch: {
    pagination: {
      handler() {
        // this.loading = true
        this.$store
          .dispatch("queryConsumerUnits")
          .then(() => {
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            console.error("Erro ao recuperar unidades consumidoras. ", error);
          });
      },
      deep: true,
    },
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage,
      );
    },
    pagination: {
      get: function () {
        return this.$store.getters.pagination;
      },
      set: function (value) {
        this.$store.commit("setPagination", value);
      },
    },
    items() {
      return this.$store.getters.items;
    },
    consumerunits() {
      return this.$store.getters.consumerunits;
    },
  },
  mounted() {
    this.loading = true;
    // this.queryConsumerUnits()
    //   .then(res => {
    //     this.consumerunits = res.items
    //   })
    //   .catch(error => {
    //     console.error('Erro ao pegar unidades consumidoras', error)
    //   })
    // getConsumerUnitsUsers({ limit: 100, page: this.pagination.page || 1, orderBy: { field: "created_at", direction: "asc" } })
    //   .then(res => {
    //     // let items = []
    //     this.consumerunits = res.docs.map(doc => {
    //       return {
    //         id: doc.id,
    //         ...doc.data()
    //       }
    //     })
    //     this.$store.dispatch('queryItems', this.consumerunits)
    //       .then((data) => {
    //         this.loading = false
    //         this.consumerunitsshow = data.items
    //         this.totalUCs = data.total
    //       })
    //     // this.$store.commit('_setItems', {items: this.consumerunits.slice(), totalItems: this.consumerunits.length})
    //   })
    //   .catch(error => {
    //     console.log('Erro ao pegar unidades consumidoras: ', error)
    //     return
    //   })
  },
  methods: {
    ...mapActions(["queryItems", "queryConsumerUnits"]),
  },
};
</script>
